import { USERS_LIST_GROUPS_COLLAPSE_THRESHOLD } from '../../dashboard/constants';

import linkedLocationsUrl from './linkedLocations.html';

class LinkedLocationsCtrl {
  constructor(UserUtils, $scope, $timeout) {
    'ngInject';

    Object.assign(this, { UserUtils, $scope, $timeout });
  }

  toggle =
    (state) =>
    (trigger = true) => {
      this.shouldShowAll = state;
      if (trigger) {
        this.$timeout(() => {
          this.$scope.$emit('vsRepeatTrigger');
        });
      }
    };

  $onInit() {
    this.displayedItemsLimit = USERS_LIST_GROUPS_COLLAPSE_THRESHOLD;

    this.showAll = this.toggle(true);
    this.showLess = this.toggle(false);

    this.canEditGroup = this.UserUtils.canEditGroup.bind(this.UserUtils);
  }
}

export default {
  bindings: {
    src: '=',
    comma: '=?',
    shouldShowAll: '=isExpanded',
  },
  templateUrl: linkedLocationsUrl,
  controller: LinkedLocationsCtrl,
  controllerAs: 'ctrl',
};
